module.exports = __webpack_public_path__ + "static/hackLogo-3b32fdead9a47ce2a7a27116836d9d86.png";